import React from 'react';
import { useSelector } from 'react-redux';

import { BasePage } from './bases/BasePage';
import { BreadcrumbSubBar } from '@components/BreadcrumbSubBar';
import { EntityPageLayout, ContentPageHeader, ContentSection } from '@components/design-system';
import { GetNotificationsCard } from '@components/notifications/GetNotificationsCard';
import { useNavAssert } from '@hooks/useNavAssert';
import { AppRoutes } from '@consts/routes';

import type { RootState } from '@features/redux/store';

/**
 * Notification Settings: one "Get Notifications" form (emails x topics x
 * organizations) plus the list of current subscriptions. Self-service and
 * external recipients are the same thing — a subscription row per
 * (email, topic, organization).
 *
 * Super admin only until the consumables service goes live.
 */
export const NotificationSettings: React.FC = () => {
    const role = useSelector((state: RootState) => state.auth.Roles.role);
    useNavAssert(role.isSuperAdmin, AppRoutes.Insights, 'Insufficient permissions to view notification settings.');

    return (
        <BasePage>
            <BreadcrumbSubBar />
            <EntityPageLayout>
                <ContentPageHeader
                    title='Notification Settings'
                    description='Subscribe any email to notifications for the organizations you can access.'
                />
                <ContentSection gap={2}>
                    <GetNotificationsCard />
                </ContentSection>
            </EntityPageLayout>
        </BasePage>
    );
};
